import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/** Resultados de cierre del modal WiFi 5G (DF-498). */
export type SimyoWifi5gNoCoverageResult = 'dismiss' | 'modify-address' | 'hire-wifi5g';

@Component({
    selector: 'app-simyo-modal-wifi5g-no-coverage',
    templateUrl: './simyo-modal-wifi5g-no-coverage.component.html',
    styleUrls: ['./simyo-modal-wifi5g-no-coverage.component.css', '../../../../assets/css/simyo-theme.css'],
    standalone: false
})
export class SimyoModalWifi5gNoCoverageComponent {
    /** Dirección consultada (mismo formato que el resumen de instalación). */
    @Input() address = '';

    readonly benefits: readonly string[] = [
        'Nuestro WiFi 5G llega donde la fibra no puede',
        'Router 5G incluido',
        'No hace falta instalación, lo recibes y lo enchufas'
    ];

    constructor(public activeModal: NgbActiveModal) {}

    dismiss(): void {
        this.activeModal.dismiss('dismiss' as SimyoWifi5gNoCoverageResult);
    }

    modifyAddress(): void {
        this.activeModal.close('modify-address' as SimyoWifi5gNoCoverageResult);
    }

    hireWifi5g(): void {
        this.activeModal.close('hire-wifi5g' as SimyoWifi5gNoCoverageResult);
    }
}
